// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"Card_formWrapper__cjain","inputWrapper":"Card_inputWrapper__3VC4E"};